import { DataModel } from "common/models/utility-models/base-model";

export class StudentListModel extends DataModel {
}




export class StudentListListChartsModel {
    Invitation: any = {};
    Availability: any = {};
    AssignedStatus: any = {};
    CompletionStatus: any = {};
    
} 


const data = {
  "totalStudent": "330",
  "totalInvitedStudent": "36",
  "totalNotInvitedStudent": "294",
  "totalInvitedButNotRespondedStudent": "3",
  "totalNotAvailableStudent": "2",
  "totalAvailableButNotAssignedStudent": "8",
  "totalAvailableAndAssignedStudent": "23",
  "totalCompletedStudent": "4",
  "totalNotCompletedStudent": "17",
  "totalNotJoinedStudent": "11",
  "TotalAvailbleStudent": 31
}
